/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1SecurityDayEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_INVENTORY_V1_SECURITY_DAY_EVENT_ENTITY_NAME = 'ixc.inventory.v1.SecurityDayEvent';
export const ixcInventoryV1SecurityDayEventEntity = new schema.Entity<IxcInventoryV1SecurityDayEvent>(IXC_INVENTORY_V1_SECURITY_DAY_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        initFirstDay: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcInventoryV1SecurityDayEvent) => `${entity.metadata?.eventId}` });

